import { Row } from 'react-table';
import { matchSorter } from 'match-sorter';

const getColumnFieldSort = (field: string) => (rowA: Row<any>, rowB: Row<any>, columnId: string) => {
  const valueA = rowA.values[columnId][field];
  const valueB = rowB.values[columnId][field];
  if (valueA === valueB) {
    return 0;
  }
  return valueA > valueB ? 1 : -1;
};

const getMultiValueColumnFieldSort = (field: string) => (rowA: Row<any>, rowB: Row<any>, columnId: string) => {
  const valuesA = rowA.values[columnId][field];
  const valuesB = rowB.values[columnId][field];

  if (valuesA.length === 1 && valuesB.length === 1) {
    if (valuesA[0] === valuesB[0]) {
      return 0;
    }

    return valuesA[0] > valuesB[0] ? 1 : -1;
  }

  if (valuesA.length === valuesB.length) {
    return 0;
  }

  return valuesA.length > valuesB.length ? 1 : -1;
};

const getColumnFieldFuzzyFilter = (field: string) => {
  const filter = (rows: Row<any>[], columnIds: string[], filterValue: string) =>
    matchSorter(rows, filterValue, { threshold: matchSorter.rankings.CONTAINS, keys: [(row: Row<any>) => row.values[columnIds[0]][field]] });
  filter.autoRemove = (val: any) => !val;
  return filter;
};

export { getColumnFieldSort, getMultiValueColumnFieldSort, getColumnFieldFuzzyFilter };
